import PropTypes from 'prop-types'
import React from 'react'

function Input({
  classes: className,
  dataCy,
  defaultValue,
  disabled,
  isSymbol,
  label,
  labelStyle,
  onInput,
  placeholder,
  theSymbol,
  tooltip,
  type,
  update,
  name,
  value,
}) {
  return (
    <div className={isSymbol}>
      <input
        className={className}
        data-cy={dataCy}
        data-hj-suppress
        defaultValue={defaultValue || ''}
        disabled={disabled}
        name={name}
        onBlur={update}
        onInput={onInput}
        onWheel={event => {
          if (event.target && type === 'number') {
            event.target.blur()
          }
        }}
        placeholder={placeholder}
        type={type || 'text'}
        value={value}
      />
      <label className="label" style={labelStyle}>
        {label}
      </label>

      <span className="symbol">{theSymbol}</span>

      {tooltip ? (
        <div className="help-label left">
          <span className="help-tip">{tooltip}</span>
        </div>
      ) : null}
    </div>
  )
}

Input.propTypes = {
  disabled: PropTypes.bool,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  update: PropTypes.func.isRequired,
  verify: PropTypes.bool,
  tooltip: PropTypes.array,
  type: PropTypes.string,
  dataCy: PropTypes.string,
}

export default Input
